var map = {
	"./Product-1.jpg": 933,
	"./Product-10.jpg": 534,
	"./Product-2.jpg": 130,
	"./Product-3.jpg": 159,
	"./Product-4.jpg": 780,
	"./Product-5.jpg": 377,
	"./Product-6.jpg": 590,
	"./Product-7.jpg": 3,
	"./Product-8.jpg": 616,
	"./Product-9.jpg": 229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 467;